import React, { useState, useRef } from 'react';
import styles from './CommonCheckbox.module.css';
function CommonCheckbox(props) {
  const {
    name,
    value,
    checked,
    onChange,
    onBlur,
    error,
    classProps,
    containerStyles,
    inputStyles,
    errorClass
  } = props;
  const { container, checkmark } = styles;
  const [isFocused, setIsFocused] = useState(false);
  const checkbox = useRef();
  const handleKeyPress = e => {
    if (e?.key != 'Enter') return;
    checkbox?.current?.click();
  };
  return (
    <div style={containerStyles}>
      <label className={`${container}`}>
        <input
          tabIndex="-1"
          type="checkbox"
          checked={checked}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          ref={checkbox}
        />
        <span
          tabIndex="0"
          onKeyDown={handleKeyPress}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className={
            `${checkmark}  ${
              isFocused
                ? 'border-2 border-green-1000'
                : 'border border-grey-1000'
            } ${classProps} ` + (error && `${errorClass}`)
          }
          style={inputStyles}
        ></span>
      </label>
    </div>
  );
}

export default CommonCheckbox;
